import FormSuccess from '../Common/Form/FormSuccess';
import PharmacyDataForm from '../User/PharmacyDataForm';
import PharmacyService from '../../Lib/PharmacyService';
import React from 'react';
import RegistrationCodeForm from '../User/RegistrationCodeForm';
import SteppedForm from '../Common/Form/SteppedForm';
import useService from '../../Hooks/useService';
import validatePharmacy from '../../Lib/FormValidations/Pharmacy';

const RegisterBranch : React.FC<{}> = () => {
    const service = useService<PharmacyService>('pharmacy');

    return (
        <SteppedForm
            stepConfig={{
                Registrierungscode: RegistrationCodeForm,
                Apothenkendaten: PharmacyDataForm,
            }}
            validations={{
                // @ts-ignore
                Registrierungscode: () => ({}),
                Apothenkendaten: validatePharmacy,
            }}
            // @ts-ignore
            onSubmit={(data) => service.register(data)}
            completeLabel="Filialapotheke registrieren"
        >
            <FormSuccess
                title="Neue Filialie registriert"
                text="Die Filialie wurde erfolgreich registriert. Sie können sofort Benutzer für diese Filiale hinzufügen"
                actionLabel="Zur Benutzerverwaltung"
                onAction={() => {}}
            />
        </SteppedForm>
    );
};

export default RegisterBranch;
